'use client';

var translations = {
    "More...": "Thêm..."
};

export { translations as default };
//# sourceMappingURL=translations.js.map
